import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataViewModule } from 'primeng/dataview';
import { Product } from '../../cart/cart.model';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { SkeletonModule } from 'primeng/skeleton';
import { CartService } from '../../cart/cart.service';
import { RouterModule } from '@angular/router';
import { Insurance } from 'src/app/dashboard/insurance/insurance/insurance.model';
import { InsuranceDetailModalComponent } from '../insurance-detail-modal/insurance-detail-modal.component';
import { ModalService } from '@ls-commons/utils/modals';
import { DialogService } from 'primeng/dynamicdialog';
import { SinisterFormComponent } from 'src/app/components/forms/sinister-form/sinister-form.component';
import { OceanografiaFormComponent } from 'src/app/components/forms/oceanografia-form/oceanografia-form.component';
import { SeguroViajeFormComponent } from 'src/app/components/forms/seguro-viaje-form/seguro-viaje-form.component';
import { ToastAtomComponent } from '../../../../../libs/shared/components/src/lib/components/atoms/toast-atom/toast-atom.component';
import { SubworksFormComponent } from 'src/app/components/forms/subworks-form/subworks-form.component';
import { ConvenioLaboralFormComponent } from 'src/app/components/forms/convenio-laboral-form/convenio-laboral-form.component';

@Component({
  selector: 'app-insurance-dataview',
  standalone: true,
  imports: [
    CommonModule,
    DataViewModule,
    SkeletonModule,
    TagModule,
    ButtonModule,
    RouterModule,
    ToastAtomComponent,
  ],
  providers: [DialogService, ModalService],
  templateUrl: './insurance-dataview.component.html',
  styleUrl: './insurance-dataview.component.scss',
})
export class InsuranceDataviewComponent {
  @Input() items: any = []; // Product[] | Insurance[] = [];
  @Output() toggleLayout: EventEmitter<string> = new EventEmitter();

  layout: 'list' | 'grid' = 'list';
  inventoryDescription: any = [];
  cartService = inject(CartService);

  dialogService = inject(DialogService);
  modalService = inject(ModalService);

  constructor(public dv: DataViewModule) {
    this.inventoryDescription['INSTOCK'] = 'Disponible';
    this.inventoryDescription['LOWSTOCK'] = 'Últimos productos';
    this.inventoryDescription['OUTOFSTOCK'] = 'No disponible';

    // this.showForm('{FORM-subworks}');
  }

  getSeverity(item: Product) {
    switch (item?.inventoryStatus) {
      case 'INSTOCK':
        return 'success';

      case 'LOWSTOCK':
        return 'warning';

      case 'OUTOFSTOCK':
        return 'danger';

      default:
        return undefined;
    }
  }

  log(item: Product) {
    console.log(item);

    // this.cartService.addProduct(item!, 1);
  }

  showDetails(element_id: string | null) {
    this.items.find(
      (element: Insurance) => element.insurance_id.toString() == element_id
    );

    // const ref =
    this.dialogService.open(InsuranceDetailModalComponent, {
      dismissableMask: true,
      // maximizable: true,
      // header: `${item?.name?.replace('(T)', '')}`,
      data: {
        element_id,
      },
      width: '100vw',
      height: '100vh',
      style: { maxHeight: '100vh', borderRadius: 0 },
      // breakpoints: { '1199px': '75vw', '575px': '100vw' },
    });
    // ref.onClose.subscribe((reload: boolean) => {
    //   // reload && this.getList();
    // });
  }

  showForm(link: string | null = null) {
    if (link) {
      let component: any = SinisterFormComponent;

      const isConvenio = link?.includes('{FORM-convenio}');
      const isOceanografico = link?.includes('{FORM-oceanografico}');
      const isSubworks = link?.includes('{FORM-subworks}');
      const isSeguroViaje = link?.includes('{FORM-seguroviaje}');

      if (isOceanografico) {
        component = OceanografiaFormComponent;
      } else if (isSubworks) {
        component = SubworksFormComponent;
      } else if (isConvenio) {
        component = ConvenioLaboralFormComponent;
      } else if (isSeguroViaje) {
        component = SeguroViajeFormComponent;
      }

      this.dialogService.open(component, {
        dismissableMask: true,
        header: isConvenio
          ? 'Solicitar contratación del seguro'
          : 'Solicitud de presupuesto',
        data: {
          // sectionAccidentsData: this.sectionAccidentsData,
        },
        width: 'calc(100% - 1rem)',
        height: '100%',
        style: { maxWidth: '1000px', maxHeight: 'calc(100% - 1rem)' },
      });
    } else {
      return;
    }
  }
}
